"use strict";

class SlideAnimation {
  constructor() {
    this.slideLeft = Array.prototype.slice.call( document.querySelectorAll( '.slide-from-left' ) );
    this.slideRight = Array.prototype.slice.call( document.querySelectorAll( '.slide-from-right' ) );
    this.slideTop = Array.prototype.slice.call( document.querySelectorAll( '.slide-from-top' ) );
    this.slideBottom = Array.prototype.slice.call( document.querySelectorAll( '.slide-from-bottom' ) );
    this.raf;
    this.events();
  }

  events() {
    window.addEventListener( 'scroll', this.rafScroll.bind(this) );
    window.addEventListener( 'load', this.slide.bind(this) );
  }

  // methods
  rafScroll() {
    if (this.raf) {
      window.cancelAnimationFrame(this.raf);
    }
      this.raf = window.requestAnimationFrame(this.slide.bind(this));
  }

  slide() {

    [ ...this.slideLeft, ...this.slideRight ].forEach( node => {
      var top = node.getBoundingClientRect().top;
    
      if( top <= 400) {
        node.classList.add( 'slide-horizontal' );
        node.style.opacity = 1;
      }
    });
  
    this.slideTop.forEach( node => {
      var top = node.getBoundingClientRect().top;
    
      if( top <= 400) {
        node.classList.add( 'slide-vertical' );
        node.style.opacity = 1;
      }
    });
  
    this.slideBottom.forEach( node => {
      var top = node.getBoundingClientRect().top;
    
      if( top <= 650 ) {
        node.classList.add( 'slide-vertical' );
        node.style.opacity = 1;
      }
    });
  }
}

export default SlideAnimation;